import { HEX_REGEX } from '@kentik/ui-shared/util/regex';

export default {
  message: 'Enter a valid hex color',
  fn: (value) => value.match(HEX_REGEX)
};
